<template>
  <div
    v-if="hasCriticalIncidencias"
    class="critical-incidencia-banner"
    role="alert"
    aria-live="assertive"
  >
    <div class="critical-incidencia-banner__content">
      <ion-icon :icon="warningOutline" class="critical-incidencia-banner__icon"></ion-icon>
      <div class="critical-incidencia-banner__text">
        <strong>PELIGRO</strong>
        —
        {{ criticalIncidenciasCount }}
        incidencia{{ criticalIncidenciasCount === 1 ? '' : 's' }}
        crítica{{ criticalIncidenciasCount === 1 ? '' : 's' }}
        (prioridad &lt; 6)
        <span v-if="mostCriticalIncidencia?.title" class="critical-incidencia-banner__title">
          · {{ mostCriticalIncidencia.title }}
        </span>
      </div>
    </div>
    <ion-button size="small" fill="solid" color="light" @click="goToIncidencias">
      Ver ahora
    </ion-button>
  </div>
</template>

<script lang="ts" setup>
import { IonButton, IonIcon } from '@ionic/vue';
import { warningOutline } from 'ionicons/icons';
import { useRouter } from 'vue-router';
import { useOpenIncidencias } from '@/composables/unreadIncidencias';

const router = useRouter();
const {
  hasCriticalIncidencias,
  criticalIncidenciasCount,
  mostCriticalIncidencia,
} = useOpenIncidencias();

const goToIncidencias = () => {
  router.push('/organizacion/incidencias');
};
</script>

<style scoped>
.critical-incidencia-banner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
  background: #7f1d1d;
  color: #fff;
  font-size: 0.9rem;
  line-height: 1.35;
  z-index: 10001;
  border-bottom: 3px solid #fecaca;
  animation: critical-pulse 1.6s ease-in-out infinite;
}

.critical-incidencia-banner__content {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.critical-incidencia-banner__icon {
  font-size: 1.5rem;
  flex-shrink: 0;
}

.critical-incidencia-banner__text {
  min-width: 0;
}

.critical-incidencia-banner__title {
  opacity: 0.92;
  font-weight: 500;
}

@keyframes critical-pulse {
  0%,
  100% {
    background: #7f1d1d;
  }
  50% {
    background: #991b1b;
  }
}
</style>
